import {useState, SetStateAction, Dispatch, useEffect} from 'react';
interface UserReportProps {
	id: number;
	startDateRef: any;
	endDateRef: any;
}

interface ReportLine {
	first_name: string;
	last_name: string;
	event: string;
	event_date: Date;
	event_time: Date;
	event_timeStr: string;
	unit: string;
	location: string
}

interface Report {
	first_name: string;
	last_name: string;
	total_hours: number;
	total_minutes: number;
	report_lines: ReportLine[];
	minutes_fraction: number;
	total_time_string: string;
}

async function GetReports(id:number, setReports:Dispatch<SetStateAction<Report[]>>, startDateRef: any, endDateRef:any, setMsg: Dispatch<SetStateAction<string>>) {
	try {
		console.log("fetching report for location " + id + " from " + startDateRef.current.valueAsDate.getTime() + " to " + endDateRef.current.valueAsDate.getTime())
		const response = await fetch(process.env.REACT_APP_API+"/api/getTimeSheetForLocation?location=" + id +"&start_date=" + startDateRef.current.valueAsDate.getTime() + "&end_date=" + endDateRef.current.valueAsDate.getTime())
		const result = await(response.json())
		var reports = await result
		console.log(reports)


		for (var report of reports) {
		
			for (var i = 0; i < report.report_lines.length; i++) {
				report.report_lines[i].event_date = new Date(report.report_lines[i].event_date)
				// Add 1 day to report.report_lines[i].event_date
				report.report_lines[i].event_date.setDate(report.report_lines[i].event_date.getDate() + 1)
				report.report_lines[i].event_time = new Date(report.report_lines[i].event_time)
				report.report_lines[i].event_time.setHours(report.report_lines[i].event_time.getHours() + 1) // adjust for timezone
			}
		}
		setReports(reports)

	} catch (error) {
		console.log(error)
	}
}

export const LocationReport = ({id, startDateRef, endDateRef}: UserReportProps) => {
	// TODO:

	const [reports, setReports] = useState<Report[]>([{first_name:"", last_name:"", total_hours: 0, total_minutes: 0, report_lines: [], minutes_fraction: 0, total_time_string: ""}])
	const [msg, setMsg] = useState("")
	
	useEffect(() =>  {
		GetReports(id, setReports, startDateRef, endDateRef,setMsg)
	},[id, setReports, startDateRef, endDateRef,setMsg])

	const getPDF = async () => {
		try {
			const response = await fetch(process.env.REACT_APP_API+"/api/getTimeSheetForLocationPDF?location=" + id +"&start_date=" + startDateRef.current.valueAsDate.getTime() + "&end_date=" + endDateRef.current.valueAsDate.getTime())
			const blob = await response.blob()
			const url = window.URL.createObjectURL(blob)
			const a = document.createElement('a')
			a.href =
				url
			a.download = 'timesheet.pdf'
			document.body.appendChild(a)
			a.click()
			a.remove()
		}
		catch (error) {
			console.log(error)
		}
	}

	if (msg !== "") {
		return (
			<div className="resilire">
				<p>{msg}</p>
			</div>
		)
	}
	
	return (
		<div className="resilire">
			{reports.map((report) => (
				<div className="resilire" key={report.first_name + report.last_name}>
				<table>
					<thead>
						<tr>
							<th>First Name</th>
							<th>Last Name</th>
							<th>Total Hours Worked</th>
						</tr>
					</thead>
					<tbody key="report_body">
						<tr>
							<td>{report.first_name}</td>
							<td>{report.last_name}</td>
							<td>{report.total_time_string} Hours</td>
						</tr>
					</tbody>
				</table>
				<br />
				<table>
					<thead>
						<tr>
							<th>Unit</th>
							<th>Location</th>
							<th>Event</th>
							<th>Date</th>
							<th>Time</th>
						</tr>
					</thead>
					<tbody key="report_lines">
						{report.report_lines && report.report_lines.map((line, index) => (
							<tr key={index}>
								<td>{line.unit}</td>
								<td>{line.location}</td>
								<td>{line.event === "sign_in" ? "Clock In" : "Clock Out"}</td>
								<td>{line.event_date.toLocaleDateString()}</td>
								<td>{line.event_time.toLocaleTimeString()}</td>
							</tr>
						))}
					</tbody>
				</table>
				<br />
				</div>
			))}

			<button onClick={getPDF}>Download</button>
		</div>
	)
};

export default LocationReport;
